import React, { Component } from 'react'
import ProjectItem from './ProjectItem.js'
import isVisible from 'in-viewport'

export class Projects extends Component {

  projectsArray = [
    {
      name: 'Clear View Escapes',
      description: 'I built this site following a Udemy course. It is a landing page for a travel company\'s website. It was built using PostCSS, Webpack and Babel.',
      url: 'https://cvescapes.netlify.com',
      github: 'https://github.com/skadewdle/travel-site',
      imagePath: '/projects-pics/cvescapes.png',
      showURL: 'bruh'
    }
  ]

  componentDidMount () {
    document.querySelectorAll('.row').forEach(cur => {
      cur.classList.add('hidden')
      isVisible(cur, { offset: -300 } ,() => {
        cur.classList.remove('hidden')
        cur.classList.add('fadeIn')
      })
    })
  }

  render() {
    return (
      <div className="projects more-top-margin">
        <div className="projects-grid">
        {
          this.projectsArray.map((cur, index) => <ProjectItem key={Math.random()} id={index + 1} name={cur.name} imagePath={cur.imagePath} github={cur.github} url={cur.url} description={cur.description}/>)
        }
        </div>
      </div>
    )
  }
}

export default Projects

